import { useState, useEffect } from 'react';

function useLocalStorage<T>() {
  const [items, setItems] = useState<T>({} as T);

  useEffect(() => {
    const storedItems = JSON.parse(localStorage.getItem('loyalty') || '{}');
    setItems(storedItems);
  }, []);

  const addItem = (id: string, data: object) => {

    const updatedItems = {...items, [id]: data};
    setItems(updatedItems);
    localStorage.setItem('loyalty', JSON.stringify(updatedItems));

  };

  const deleteItem = (itemId: string) => {
    const updatedItems: any = { ...items };
    delete updatedItems[itemId];
  
    setItems(updatedItems);
    localStorage.setItem('loyalty', JSON.stringify(updatedItems));
  };
  

  return { items, addItem, deleteItem };
};

export default useLocalStorage;